import _ from "lodash";
import {Auth} from "../../components/Authorization";
import {SnackBar} from "../../components/common";
import {getActionData} from "_helpers";
import {userInviteService} from "_services";
import {alertMessages, requestOrigin, storageKey, userInviteConstants} from "_constants";
import {userActions} from "../user.actions";

function get(id) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.GET_USER_INVITE_REQUEST));
        userInviteService.get(id)
            .then(response => {
                dispatch(getActionData(userInviteConstants.GET_USER_INVITE_SUCCESS, response.data));
            }).catch((error) => {
                const status = _.get(error, 'response.status');
                if (status === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(userInviteConstants.GET_USER_INVITE_FAILURE, {}, error));
                handleErrorMessage(error);
        });
    }
}

function list(params) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.LIST_USER_INVITE_REQUEST));
        userInviteService.list(params)
            .then(response => {
                dispatch(getActionData(userInviteConstants.LIST_USER_INVITE_SUCCESS, response.data));
            }).catch((error) => {
                const status = _.get(error, 'response.status');
                if (status === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(userInviteConstants.LIST_USER_INVITE_FAILURE, {}, error));
                handleErrorMessage(error);
        });
    }
}

function accept(payload) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.ACCEPT_USER_INVITE_REQUEST));
        userInviteService.accept(payload)
            .then(response => {
                const {userData} = response.data;
                const parsedUser = JSON.parse(userData || '{}');

                localStorage.setItem('user', userData);
                dispatch(getActionData(userInviteConstants.ACCEPT_USER_INVITE_SUCCESS, response.data));
                dispatch(userActions.getCurrentUser(parsedUser.id, requestOrigin.INVITE));
            }).catch((error) => {
            dispatch(getActionData(userInviteConstants.ACCEPT_USER_INVITE_FAILURE, {}, error?.response?.data));
            handleErrorMessage(error);
        });
    }
}

function revoke(id) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.REVOKE_USER_INVITE_REQUEST, {id}));
        userInviteService.revoke(id)
            .then(response => {
                dispatch(getActionData(userInviteConstants.REVOKE_USER_INVITE_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.USER_INVITE_REVOKE);
            }).catch((error) => {
                const status = _.get(error, 'response.status');
                if (status === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(userInviteConstants.REVOKE_USER_INVITE_FAILURE, {}, error));
                handleErrorMessage(error);
        });
    }
}

function unrevoke(id) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.UNREVOKE_USER_INVITE_REQUEST, {id}));
        userInviteService.unrevoke(id)
            .then(response => {
                dispatch(getActionData(userInviteConstants.UNREVOKE_USER_INVITE_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.USER_INVITE_UNREVOKE);
            }).catch((error) => {
                const status = _.get(error, 'response.status');
                if (status === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(userInviteConstants.UNREVOKE_USER_INVITE_FAILURE, {}, error));
                handleErrorMessage(error);
        });
    }
}

function resend(id, payload) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.RESEND_USER_INVITE_REQUEST, {id}));
        userInviteService.resend(id, payload)
            .then(response => {
                dispatch(getActionData(userInviteConstants.RESEND_USER_INVITE_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.USER_INVITE_RESEND);
            }).catch((error) => {
                const status = _.get(error, 'response.status');
                if (status === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(userInviteConstants.RESEND_USER_INVITE_FAILURE, {}, error));
                handleErrorMessage(error);
        });
    }
}

function create(payload) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.CREATE_USER_INVITE_REQUEST));
        userInviteService.create(payload)
            .then(response => {
                dispatch(getActionData(userInviteConstants.CREATE_USER_INVITE_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.USER_INVITE_CREATE);
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(userInviteConstants.CREATE_USER_INVITE_FAILURE, {}, error));
            handleErrorMessage(error);
        });
    }
}

function passwordStatus() {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.PASSWORD_STATUS_REQUEST));
        userInviteService.passwordStatus()
            .then(response => {
                dispatch(getActionData(userInviteConstants.PASSWORD_STATUS_SUCCESS, response.data));
                localStorage.setItem(storageKey.PASSWORD_STATUS, JSON.stringify(response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(userInviteConstants.PASSWORD_STATUS_FAILURE, {}, error));
        });
    }
}

function createPassword(payload) {
    return (dispatch) => {
        dispatch(getActionData(userInviteConstants.CREATE_PASSWORD_REQUEST));
        userInviteService.createPassword(payload)
            .then(response => {
                dispatch(getActionData(userInviteConstants.CREATE_PASSWORD_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.CREATE_PASSWORD_SUCCESS);
                updatePasswordStatus();

                setTimeout(() => {
                }, 1000);

                window.location.href = '/profile';
            }).catch((error) => {
            dispatch(getActionData(userInviteConstants.CREATE_PASSWORD_FAILURE, {}, error));
            const messageFromServer = _.get(error, 'response.data.message');
            SnackBar.showMessage((messageFromServer || alertMessages.CREATE_PASSWORD_FAILURE));
        });
    }
}

function handleErrorMessage(error) {
    const status = _.get(error, 'response.status');
    const messageFromServer = _.get(error, 'response.data.message');
    const message = (status === 404)
        ? alertMessages.USER_INVITE_NOT_FOUND
        : (messageFromServer || alertMessages.GENERIC_ERROR);
    SnackBar.showMessage(message);
}

function updatePasswordStatus() {
    const cachedStatusStr = localStorage.getItem(storageKey.PASSWORD_STATUS);
    if (!cachedStatusStr) return;

    try {
        const cachedStatus = JSON.parse(cachedStatusStr);
        if (cachedStatus.hasUserSetOwnPassword === false) {
            cachedStatus.hasUserSetOwnPassword = true;
            localStorage.setItem(storageKey.PASSWORD_STATUS, JSON.stringify(cachedStatus));
        }
    } catch (e) {
        console.error('Failed to parse passwordStatus from localStorage:', e);
    }
}

export const userInviteActions = {
    get,
    list,
    accept,
    revoke,
    unrevoke,
    resend,
    create,
    passwordStatus,
    createPassword
};